import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as policy from '../policy'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: policy.RESOURCE.payload.dimension.partialId,
      partialId: policy.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'The role or team responsible for this policy (e.g. Director of Information Technology, Human Resources).',
    isOptional: true,
    name: 'Owner',
    partialId: PartialId.Standard.create('owner'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
